// Half-open ranges make an exact boundary belong only to the next clip.
export const highlightsAtTime = (highlights, time) => {
  if (!Number.isFinite(time)) return []
  return highlights.filter(({ start, end }) => (
    Number.isFinite(start) && Number.isFinite(end) && start <= time && time < end
  ))
}

export const overlappingHighlights = (highlights, start, end) => {
  if (!Number.isFinite(start) || !Number.isFinite(end) || end <= start) return []
  return highlights.filter(clip => (
    Number.isFinite(clip.start) && Number.isFinite(clip.end) &&
    clip.end > clip.start && clip.start < end && clip.end > start
  ))
}
